import {Breakpoints, styled} from '@vw-marketing/us-components';

export const ShowMoreTextWrapper = styled.div`
  display: flex;
  flex-direction column;
  gap: 10px;
  width: 100%;
  position: relative;
`;

export const StyledDescription = styled.div`
  font-family: 'vw-text';
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #3c484d;
  position: relative;
`;

export const StyledList = styled.ul`
  padding: 0;
  margin: 3px 0px;
  list-style-type: none;
`;

export const StyledListItem = styled.li`
  color: #000;
  display: flex;
  font-size: 16px;
  line-height: 24px;
  font-style: normal;
  font-weight: normal;
  font-stretch: normal;
  font-family: 'vw-text';
  letter-spacing: normal;
`;

export const StyledHypen = styled.span`
  &:before {
    content: '—';
  }
  margin-right: 9px;
`;

export const StyledFadedBox = styled.div`
  content: '';
  width: 100%;
  height: 50%;
  position: absolute;
  left: 0;
  bottom: 0;
  background: -moz-linear-gradient(
    180deg,
    rgba(249, 249, 249, 0) 0%,
    rgba(249, 249, 249, 1) 100%
  );
  background: -webkit-linear-gradient(
    180deg,
    rgba(249, 249, 249, 0) 0%,
    rgba(249, 249, 249, 1) 100%
  );
  background: linear-gradient(
    180deg,
    rgba(249, 249, 249, 0) 0%,
    rgba(249, 249, 249, 1) 100%
  );
`;

export const StyledShowMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 10px 0 0;
  color: #001e50;
  font-size: 14px;

  @media (min-width: ${Breakpoints.b560}px) {
    justify-content: flex-start;
  }

  &:hover {
    .show-more-button {
      cursor: pointer;
      color: #0040c5;
    }

    .chevron-arrow {
      cursor: pointer;
      path {
        fill: #0040c5;
      }
    }
  }
`;

export const StyledButtonText = styled.span`
  display: none;

  @media (min-width: ${Breakpoints.b560}px) {
    display: block;
  }
`;

export const StyledShowMoreButton = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;
